import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../core/services/web-storage';
import { GrupoClassificacaoFilter } from './grupo-classificacao-filter';
import { GrupoClassificacaoFilterStorage } from './grupo-classificacao-filter-storage';

/**
 * Service utilizado para armazenar os dados do filter da tipos de classificações no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class GrupoClassificacaoFilterStorageService {
    private key = 'grupoClassificacaoFilter';

    constructor(private sessionStorageService: SessionStorageService) { }


    /** Obtem os dados do filtro armazenados */
    get(): GrupoClassificacaoFilterStorage {
        const data = this.sessionStorageService.getObject(this.key) as GrupoClassificacaoFilterStorage;
        if (data) {
            // Criando um Map com os campos filtrados e seus respectivos valores
            data.filterValues = new Map();
            const keys = Object.keys(data.filter);
            keys.forEach(key => data.filterValues.set(key, data.filter[key]));
        }

        return data;
    }

    /** Armazena os dados do filtro */
    set(filter: GrupoClassificacaoFilter) {
        const data = new GrupoClassificacaoFilterStorage(filter);
        this.sessionStorageService.setObject(this.key, data);
    }

    /** Remove os dados do filtro */
    remove() {
        this.sessionStorageService.remove(this.key);
    }

    /** Verifica se possui filtro salvo no storage */
    hasFilter(): boolean {
        const filter = this.get();
        return filter != null && filter !== undefined;
    }

    /** Aplica o filtro armazenado no objeto do filtro informado */
    applyFilter(filter: GrupoClassificacaoFilter) {
        const filterStorage = this.get();
        if (filterStorage != null) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                filterStorage.filterValues.forEach((value, key) => filter[key] = value);
            }
        }
    }
}
